<template>
  <div class="m_covert_page">
    <h1 class="mcrt_title">{{ covertTitle }} 在线转换</h1>
    <div class="file2file_cntr">
      <File2file
        :cmd="cmd" :fileType="fileType" :toFileType="toFileType"
        :covertTitle="covertTitle" :targetTypes="targetTypes" :customOptionType="customOptionType" />
    </div>
    <!-- 功能介绍 -->
    <FunctionIntro :covertTitle="covertTitle" :fileType="fileType" :toFileType="toFileType" />
  </div>
</template>

<script>
import getProps from '@/components/common/CovertPage/getProps'
import FunctionIntro from '@/components/common/Convert/FunctionIntro'

export default {
  components: {
    File2file: () => import('@/components/common/CovertPage/File2file'),
    FunctionIntro
  },

  props: getProps(),
}
</script>

<style lang="scss">
  .m_covert_page {
    .mcrt_title { position: relative; padding-left: 12px; font-size: 20px; font-weight: bold; line-height: 22px; color: #333; border-left: 3px solid #548ef8; }
    .file2file_cntr { min-height: 300px; }
  }
</style>
